export default __webpack_public_path__ + "static/media/DNo.13-0.48ae4206.jpg";